import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const gerenciarBaremaRoutes: Routes = [
  {
    path: 'gerenciar-barema',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Gerenciar Barema',
      breadcrump: [{ label: 'Gerenciar Barema' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./gerenciar-barema-list/gerenciar-barema-list.component').then(
            (m) => m.GerenciarBaremaListComponent,
          ),
        data: {
          title: 'Gerenciar Barema',
          roles: [Role.BAREMA_CONSULTAR],
          breadcrump: [{ label: 'Gerenciar Barema', url: '/gerenciar-barema' }],
        },
      },
      {
        path: 'ciclo/:cicloId',
        loadComponent: () =>
          import('./gerenciar-barema-ciclo/gerenciar-barema-ciclo.component').then(
            (m) => m.GerenciarBaremaCicloComponent,
          ),
        data: {
          title: 'Gerenciar Barema - Itens',
          roles: [Role.BAREMA_CONSULTAR],
          breadcrump: [
            { label: 'Gerenciar Barema', url: '/gerenciar-barema' },
            { label: 'Itens do Barema' },
          ],
        },
      },
      {
        path: 'ciclo/:cicloId/item/:itemId/profissionais',
        loadComponent: () =>
          import('./profissionais-por-item/profissionais-por-item.component').then(
            (m) => m.ProfissionaisPorItemComponent,
          ),
        data: {
          title: 'Profissionais por Item',
          roles: [Role.BAREMA_CONSULTAR],
          breadcrump: [
            { label: 'Gerenciar Barema', url: '/gerenciar-barema' },
            { label: 'Itens do Barema', url: '/gerenciar-barema/ciclo/:cicloId' },
            { label: 'Profissionais' },
          ],
        },
      },
      {
        path: 'ciclo/:cicloId/item/:itemId/upload/:uploadId/profissionais',
        loadComponent: () =>
          import('./profissionais-identificados/profissionais-identificados.component').then(
            (m) => m.ProfissionaisIdentificadosComponent,
          ),
        data: {
          title: 'Profissionais Identificados',
          roles: [Role.BAREMA_CONSULTAR],
          breadcrump: [
            { label: 'Gerenciar Barema', url: '/gerenciar-barema' },
            { label: 'Itens do Barema', url: '/gerenciar-barema/ciclo/:cicloId' },
            { label: 'Profissionais Identificados' },
          ],
        },
      },
    ],
  },
];
